import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';

export default function MemberRankingsCard({ rankings = {} }) {
  // Convert the rankings object into an array of [pennantName, rank] pairs
  const rankingEntries = Object.entries(rankings);

  if (!rankingEntries.length) {
    return (
      <Card sx={{ margin: 2, padding: 2 }}>
        <CardHeader title="My Rankings" />
        <CardContent>
          <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center', marginY: 2 }}>
            No rankings available.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="My Rankings" />
      <CardContent>
        <List>
          {rankingEntries.map(([pennantName, rank], idx) => (
            <React.Fragment key={pennantName}>
              <ListItem sx={{ paddingY: 2, alignItems: 'flex-start' }}>
                <ListItemText
                  primary={
                    <Typography variant="h6" color="primary">
                      {pennantName}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      Ranking: {rank}
                    </Typography>
                  }
                />
              </ListItem>
              {idx < rankingEntries.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
